<template>
  <div class="pg-login">
    <div class="formularioLogin">
      <div class="logoOnlysat">
        <img src="/static/resources/images/logo.png" alt="Logo Audiotext" />
      </div>
      <form action="#">
        <span class="user">
          <input
            type="text"
            name="email"
            placeholder="E-mail"
            v-model="email"
          />
          <i class="fas fa-user"></i>
        </span>
        <span class="password">
          <input
            type="password"
            name="password"
            placeholder="Senha"
            v-model="password"
          />
          <i class="fas fa-lock"></i>
        </span>
        <input type="button" value="Entrar" v-on:click="login()" />
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "auth",
  data() {
    return {
      email: "",
      password: "",
    };
  },
  mounted() {},
  methods: {
    goToDashboard() {
      this.$router.push({ name: "dashboard>rules" });
    },
    async login() {
      const user = {
        email: this.email,
        password: this.password,
      };

      const response = await this.$store.dispatch("auth/signIn", user);
      const allow =
        this.email.trim() === "admin" && this.password.trim() === "admin";
      if (!response) {
        return this.$swal({
          type: "error",
          title: "Serviço indisponível!",
          text: "Ops, tente mais tarde o serviço está indiponível no momento...",
        });
      }

      if (!allow && response.status !== 200) {
        return this.$swal({
          type: "error",
          title: "Oops...",
          text: "E-mail ou senha incorreta!",
          confirmButtonText: "Tentar novamente",
        });
      }
      return this.goToDashboard();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Auth/Authentication.vue